import { DialogButton } from "./DialogButton";

export const Mod = {
  DialogButton,
};
